import React, { useEffect, useState } from 'react';
import './callLogPanel.css';
import { BlandService } from '../../../../services/blandService';

function formatDate(ms) {
    return new Date(ms).toLocaleString();
}

export default function CallLogPanel({ data, isCallPanelOpen, setCallPanelOpen }) {
    const logs = data?.blandCalls || [];
    const [audioUrls, setAudioUrls] = useState({});
    useEffect(() => {
        logs.forEach((log) => {
            if (log.recordingPath && !audioUrls[log.callId]) {
                BlandService.getCallRecording(log.recordingPath)
                    .then((response) => {
                        const audioUrl = URL.createObjectURL(response.data);
                        setAudioUrls((prev) => ({ ...prev, [log.callId]: audioUrl }));
                    })
                    .catch((error) => {
                        console.error(`Failed to fetch audio for callId ${log.callId}:`, error);
                    });
            }
        });

        return () => {
            // Cleanup: Revoke object URLs
            Object.values(audioUrls).forEach((url) => URL.revokeObjectURL(url));
        };
    }, [logs]);

    return (
        <>


            <div className={`side-panel ${isCallPanelOpen ? 'open' : ''}`}>
                <div className="panel-header">
                    <h2>Call Logs</h2>
                    <button className="close-btn" onClick={() => setCallPanelOpen(false)}>×</button>
                </div>

                <div className="panel-body">
                    {logs.length === 0 && <p>No call logs available.</p>}
                    {logs.map(log =>
                    (
                        <div key={log.callId} className="call-item">
                            <div><strong>Status:</strong> {log.callStatus}</div>
                            <div><strong>Candidate:</strong> {log.candidateId}</div>
                            <div><strong>Phone:</strong> {log.phoneNumber}</div>
                            <div><strong>Date:</strong> {formatDate(log.callDate)}</div>
                            <div><strong>Transcript:</strong>
                                <pre className="transcript">{log.transcript}</pre>
                            </div>
                            <div><strong>Recording:</strong>
                                <div>
                                    {audioUrls[log.callId] ? (
                                        <audio controls src={audioUrls[log.callId]} />
                                    ) : (
                                        <span>Loading audio...</span>
                                    )}
                                </div>
                            </div>
                            <hr />
                        </div>
                    )
                    )}
                </div>
            </div>
        </>
    );
}